import { Api } from '../api';
import { users } from '../endpoints';
import type { ApiResponse, ApiPaginate, ProfileResponse } from '@shared/api';
import type {
  AddUserAccountsRequest,
  AddUserCardsRequest,
  CreateUserRequest,
  DeleteUserAccountsRequest,
  DeleteUserCardsRequest,
  GenerateCodeRequest,
  GenerateCodeResponse,
  UpdatePasswordRequest,
  UsersRequest,
  UserResponse,
  UserUpdateRequest,
} from './models';

export class UsersApi extends Api {
  static getUsers = (request: UsersRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<UserResponse[]>>({ url: users.getUsers(), queryParams: request, signal });

  static getUser = (id: string, signal?: AbortSignal) => this.get<ApiResponse<UserResponse>>({ url: users.getUser(id), signal });

  static addUser = (request: CreateUserRequest) => this.post<CreateUserRequest, ApiResponse<UserResponse>>({ url: users.getUsers(), data: request });

  static updateUser = ({ id, ...data }: UserUpdateRequest, signal?: AbortSignal) =>
    this.put<Omit<UserUpdateRequest, 'id'>, ApiResponse<UserResponse>>({ url: users.updateUser(id), data, signal });

  static lockUser = (id: string, signal?: AbortSignal) => this.put<null, ApiResponse<ProfileResponse>>({ url: users.lockUser(id), signal });

  static unlockUser = (id: string, signal?: AbortSignal) => this.put<null, ApiResponse<ProfileResponse>>({ url: users.unlockUser(id), signal });

  static deleteUser = (id: string) => this.delete<null, ApiResponse<number>>({ url: users.deleteUser(id) });

  static updatePassword = (request: UpdatePasswordRequest, signal?: AbortSignal) =>
    this.put<UpdatePasswordRequest, ApiResponse<ProfileResponse>>({ url: users.updatePassword(), data: request, signal });

  static addUserAccounts = (request: AddUserAccountsRequest, signal?: AbortSignal) =>
    this.put<AddUserAccountsRequest, ApiResponse<ProfileResponse>>({ url: users.addUserAccounts(), data: request, signal });

  static deleteUserAccounts = (request: DeleteUserAccountsRequest, signal?: AbortSignal) =>
    this.delete<DeleteUserAccountsRequest, ApiResponse<ProfileResponse>>({ url: users.deleteUserAccounts(), data: request, signal });

  static generateCode = (request: GenerateCodeRequest, signal?: AbortSignal) =>
    this.put<GenerateCodeRequest, ApiResponse<GenerateCodeResponse>>({ url: users.degenerateCode(), data: request, signal });

  static addUserCards = (request: AddUserCardsRequest, signal?: AbortSignal) =>
    this.put<AddUserCardsRequest, ApiResponse<UserResponse>>({ url: users.addUserCards(), data: request, signal });

  static deleteUserCards = (request: DeleteUserCardsRequest, signal?: AbortSignal) =>
    this.delete<DeleteUserCardsRequest, ApiResponse<ProfileResponse>>({ url: users.deleteUserCards(), data: request, signal });

  static getAccountUsers = (request: UsersRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<UserResponse[]>>({ url: users.getUsers(), queryParams: request, signal });
}
